import { styled } from 'styled-components';
import { Typography, tk } from '@sunwebgroup/ui-components';
import { useIntl } from '@/intl';
import { usePromotedPrice } from '@/domain/prices/promoted-price/hooks';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;

  background: #f3efeb;
  color: #837868;

  border-radius: 10px;
  padding: ${tk('spacing_md')};

  ${Typography}:first-child {
    margin-right: ${tk('spacing_2xs')};
  }

  @media ${tk('mq_tablet')} {
    justify-content: center;
    flex-direction: row;
    margin-top: ${tk('spacing_sm')};
    margin-bottom: ${tk('spacing_lg')};
  }
`;

export function UrgencyBanner() {
  const intl = useIntl();
  const { data } = usePromotedPrice();

  if (!data) return null;

  const showBanner = data.price.discountPercentage > 0 || data?.campaignId;

  if (!showBanner) return null;

  return (
    <Wrapper className="discount-banner">
      <Typography $variant="body-md-bold">
        {intl.formatMessage({ id: 'prices_emergency_banner_strong_text' })}
      </Typography>
      <Typography>{intl.formatMessage({ id: 'prices_emergency_banner_text' })}</Typography>
    </Wrapper>
  );
}
